import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownService } from 'src/app/metricas/service/dropdown-metricas.service';
import { MetricasService } from 'src/app/metricas/service/metricas.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-filtro-acoes',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './filtro-acoes.component.html',
  styleUrls: ['./filtro-acoes.component.scss'],
})
export class FiltroAcoesComponent {
  BASE_IMG_URL = environment.BASE_IMG_URL;
  @Input() acoes: any[] = [];
  @Input() filtroAcoesSelecionados: any[] = [];
  @Output() filtroAcoesSelecionadosChange = new EventEmitter<any[]>();
  @Output() limpaAcoes = new EventEmitter<string>();
  @Output() atualizandoMetricasChange = new EventEmitter<boolean>();

  mostrarR;

  mostrarAcoes = false;

  constructor(
    private _metricasService: MetricasService,
    private dropdownService: DropdownService
  ) {}

  ngOnInit(): void {
    this.displayAcoes();

    this.dropdownService.getActiveDropdown().subscribe((active) => {
      if (active !== 'acoes') {
        this.mostrarAcoes = false;
      }
    });
  }

  toggleAcoes() {
    const isOpening = !this.mostrarAcoes;
    this.dropdownService.setActiveDropdown(isOpening ? 'acoes' : null);
    this.mostrarAcoes = isOpening;
  }

  limparAcoes() {
    this.filtroAcoesSelecionados = [];
    this.filtroAcoesSelecionadosChange.emit(this.filtroAcoesSelecionados);
    this.mostrarAcoes = false;

    this.limpaAcoes.emit();
    this.atualizandoMetricasChange.emit(false);
  }

  onAcoesToggle(acao: any, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.filtroAcoesSelecionados.push(acao);
    } else {
      this.filtroAcoesSelecionados = this.filtroAcoesSelecionados.filter(
        (selected) => selected !== acao
      );
    }
    this.filtroAcoesSelecionadosChange.emit(this.filtroAcoesSelecionados);

    const selectedActionIds = this.filtroAcoesSelecionados
      .map((acao) => acao.id)
      .join(',');

    this.atualizandoMetricasChange.emit(true);
    this.limpaAcoes.emit(selectedActionIds);
  }

  displayAcoes(): void {
    this._metricasService.listActions().subscribe(
      (response) => {
        this.acoes = response.data;
      },
      (error) => {
        console.error('Erro ao buscar ações:', error);
      }
    );
  }
}
